import { jsxs as l, jsx as s } from "react/jsx-runtime";
import { a as r } from "../../core-DVmjA3_O.js";
import { _ as N } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import g from "../Spinner/index.js";
import '../../index42.css';const u = "_message_v8cyr_1", x = "_icon_v8cyr_12", D = "_spinner_v8cyr_18", j = "_title_v8cyr_24", w = "_errored_v8cyr_30", T = "_compact_v8cyr_36", e = {
  message: u,
  icon: x,
  spinner: D,
  title: j,
  errored: w,
  compact: T
};
function z(d) {
  const {
    className: p,
    pending: c = !1,
    variant: _,
    icon: o,
    title: t,
    description: n,
    actions: a,
    compact: v = !1,
    errored: i,
    erroredTitle: m,
    erroredDescription: f
  } = d, h = i ? r(m) : r(t), y = i ? r(f) : r(n);
  return /* @__PURE__ */ l(
    "div",
    {
      className: N(
        e.message,
        _ === "error" && e.errored,
        v && e.compact,
        p
      ),
      children: [
        (o || c) && /* @__PURE__ */ l("div", { className: e.icon, children: [
          c && /* @__PURE__ */ s(g, { className: e.spinner }),
          !c && o
        ] }),
        h && /* @__PURE__ */ s("div", { className: e.title, children: i ? m : t }),
        y && /* @__PURE__ */ s("div", { className: e.description, children: n }),
        a && /* @__PURE__ */ s("div", { className: e.actions, children: a })
      ]
    }
  );
}
export {
  z as default
};
